export default __webpack_public_path__ + "static/media/logo-text.09131e01.svg";